import { useMemo, useState } from 'react'

import { Field, Label, SimpleInput } from '@makyoapp/makyo-ui'

import { RequirementFieldProps, RequirementLink } from './Requirements'

export interface TextFieldProps extends RequirementFieldProps {
  type?: string
  value?: string
}
export default function TextField({ requirement, type, onValue, value: initialValue }: TextFieldProps) {
  // TODO: get current user language
  const lang = useMemo(() => 'en', [])

  // ─── States ──────────────────────────────────────────────────────────────────
  const [value, setValue] = useState(initialValue ?? '')

  const onChange = (v: string) => {
    setValue(v)
    onValue(v)
  }

  const handleClear = () => {
    setValue('')
    onValue('')
  }

  return (
    <Field>
      <Label required={requirement._IsMandatory}>{requirement._Label[lang]}</Label>
      <SimpleInput
        required={requirement._IsMandatory}
        type={type}
        description={requirement._Description[lang]}
        onBlur={(e) => onValue(e.target.value)}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        showClear={!!value}
        onClear={handleClear}
      />
      <RequirementLink requirement={requirement} />
    </Field>
  )
}
